import { School } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  AppBar,
  ClickAwayListener,
  Fade,
  Icon,
  IconButton,
  Paper,
  Popper,
  Toolbar,
  Typography,
} from '@mui/material';
import React from 'react';

import { Content } from '~/scenes/MyWorkspace/components/Widgets/components/SolaIntelWidget/components/Content';
import { Optional } from '~/types';

import { useSxStyles } from './useStyles';

type Props = {
  anchorEl: Optional<HTMLButtonElement>;
  title: string;
  allowClickAwayClose?: boolean;
  onClose: () => void;
};

export const SolaIntel: React.FC<Props> = ({
  anchorEl,
  title,
  onClose,
  allowClickAwayClose,
}) => {
  const sxStyles = useSxStyles();
  if (!anchorEl) {
    return null;
  }
  return (
    <ClickAwayListener
      onClickAway={onClose}
      mouseEvent={allowClickAwayClose ? 'onMouseUp' : false}
      touchEvent={allowClickAwayClose ? 'onTouchEnd' : false}
    >
      <Popper
        sx={sxStyles.root}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="top-start"
        transition
        onReset={undefined}
        onResetCapture={undefined}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={sxStyles.rootPaper}>
              <AppBar position="sticky" component="div" sx={sxStyles.appBar}>
                <Toolbar sx={sxStyles.toolbar}>
                  <Icon color="inherit">
                    <School />
                  </Icon>
                  <Typography
                    sx={sxStyles.toolbarTitle}
                    variant="subtitle2"
                    color="inherit"
                  >
                    {title}
                  </Typography>
                  <IconButton
                    sx={sxStyles.toolbarIconButton}
                    color="inherit"
                    aria-label="Close"
                    onClick={onClose}
                    size="large"
                  >
                    <CloseIcon sx={sxStyles.toolbarIcon} />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <Paper sx={sxStyles.content}>
                <Content containerWidth={320} />
              </Paper>
            </Paper>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  );
};
